/**
 * @author Sumit Majumdar
 * @email sumit@grexit.com
 * @create date 2018-03-28 11:26:47
 * @modify date 2018-03-28 11:26:47
 * @desc [description]
*/
import {
    TOGGLE_CONNECTOR_ENABLED,
    FETCH_CONNECTOR_DONE,
    SETUP_CONNECTOR_DONE,
    FETCH_CONNECTOR_INIT,
    SETUP_CONNECTOR_INIT,
    FETCH_CONNECTOR_FAILED,
    SETUP_CONNECTOR_FAILED,
    FETCH_CONNECTOR_CHANNELS_DONE,
    FETCH_CONNECTOR_CHANNELS_INIT,
    FETCH_CONNECTOR_CHANNELS_FAILED,
    SAVE_CONNECTOR_TYPE_INIT,
    SAVE_CONNECTOR_TYPE_DONE,
    SAVE_CONNECTOR_TYPE_FAILED,
    DISABLE_CONNECTOR_INIT,
    DISABLE_CONNECTOR_DONE,
    DISABLE_CONNECTOR_FAILED,
    typeDataMap
} from '../actions';
import { CHANGE_UNSAVED_CHANGES } from 'h-commons';
import initState from './initState';
import onConnectorSuccess from './onConnectorSuccess';

const connectorReducer = (state = initState, action) => {
    switch(action.type) {
        case SETUP_CONNECTOR_INIT:
        case FETCH_CONNECTOR_INIT:
        case FETCH_CONNECTOR_CHANNELS_INIT:
        case SAVE_CONNECTOR_TYPE_INIT:
        case DISABLE_CONNECTOR_INIT:
            return { ...state, isLoading: action.payload || true };
        case FETCH_CONNECTOR_FAILED:
        case SETUP_CONNECTOR_FAILED: 
        case FETCH_CONNECTOR_CHANNELS_FAILED:
        case SAVE_CONNECTOR_TYPE_FAILED:
        case DISABLE_CONNECTOR_FAILED:
        case SAVE_CONNECTOR_TYPE_DONE:
            return { ...state, isLoading: false };
        case TOGGLE_CONNECTOR_ENABLED:
            const { connectorId } = action.payload;
            const idx = state.findIndex(connector => connector.id === connectorId);
            if(idx > -1) {
                const connector = Object.assign({}, state[idx], { enabled: !state[idx].enabled });
                return [ ...state.slice(0, idx), connector, ...state.slice(idx + 1)]
            }
            return state;
        case DISABLE_CONNECTOR_DONE:
        case FETCH_CONNECTOR_DONE:
        case SETUP_CONNECTOR_DONE:
            return onConnectorSuccess(state, action);
        case CHANGE_UNSAVED_CHANGES:
            if(action.payload === true) return state;
            const { sharedMailboxes } = state;
            const newSharedMailboxes = { ...sharedMailboxes };
            Object.keys(newSharedMailboxes).forEach(smid => {
                const sm = newSharedMailboxes[smid];
                Object.keys(sm).forEach(connectorType => {
                    sm[connectorType].shouldExpand = false;
                });
            });
            return {
                ...state,
                sharedMailboxes: newSharedMailboxes
            };
        case FETCH_CONNECTOR_CHANNELS_DONE:
            const { selectOptions, smid, type } = action.payload;
            const { connectors } = state;
            const thisConnector = connectors[type];
            if (thisConnector) {
                return {
                    ...state, 
                    isLoading: false,
                    connectors: {
                        ...connectors,
                        [type]: {
                            ...thisConnector,
                            selectOptions
                        }
                    }
                }
            }
            return state;
        default:
            return state;
    }
}
export {
    connectorReducer
}